module.exports = __webpack_public_path__ + "3feb5348cd877b4c096f1fdfd14aea27.svg";